/**
 * useDemoMode Hook
 *
 * Manages demo mode state with localStorage persistence.
 * When enabled, chat queries are automatically scoped to
 * the "Valley Equipment" client for demonstration purposes.
 */

import { useCallback } from 'react';
import { useLocalStorage } from './useLocalStorage';

/** The client name used when demo mode is enabled */
export const DEMO_CLIENT = 'Valley Equipment';

interface UseDemoModeReturn {
  /** Whether demo mode is currently enabled */
  isDemoMode: boolean;
  /** Toggle or set demo mode state */
  setDemoMode: (enabled: boolean) => void;
  /** The client name to use when demo mode is enabled, undefined otherwise */
  demoClient: string | undefined;
}

export function useDemoMode(): UseDemoModeReturn {
  const [isDemoMode, setStoredDemoMode] = useLocalStorage<boolean>(
    'demo_mode',
    false,
  );

  const setDemoMode = useCallback(
    (enabled: boolean) => {
      setStoredDemoMode(enabled);
    },
    [setStoredDemoMode],
  );

  return {
    isDemoMode,
    setDemoMode,
    demoClient: isDemoMode ? DEMO_CLIENT : undefined,
  };
}
